import {IFaceMatch } from '../@types/FaceMatch';
import { useEffect,useState } from 'react';
import axios from "axios";

type IProps = {
  face: IFaceMatch;
  imgWidth: string,
  imgHeight: string,
  showLastSeen?: boolean,
}

const TagModelComponent: React.FC<IProps> = (props:IProps) => {

  const [currentPersonUrl, setPersonUrl] = useState('');
  const [currentThumbnailUrl, setThumbnailUrl] = useState('');
  const [siteICO, setSiteICO] = useState('');

  

  useEffect(()=>{
    setThumbnailUrl(props.face.thumbnailUrl);
    setPersonUrl(props.face.personUrl);
    setSiteICO('images/' + props.face.siteCode + '.webp');
}, []); // empty array means only once

  async function handleImageError(e:any){
    axios
    .get(props.face.thumbnailUrl,{responseType:"blob",timeout: 5000})
    .then((resp) => {
      if(resp.data.type==='image/jpeg'){
        setThumbnailUrl(props.face.thumbnailUrl);
        e.target.src = props.face.thumbnailUrl;
      }else{
        setThumbnailUrl('images/unknown.gif');
        e.target.src = 'images/unknown.gif';
      }
    })
    .catch(() => {
      setThumbnailUrl('images/unknown.gif');
      console.clear();
    });
   }  
  function openInNewTab(url:string){
    window.open(url, "_blank", "noreferrer");
  };

return (
    <div className="results">
      <div>
            <div className='thumb' role="link" onClick={() => openInNewTab(currentPersonUrl)} style={{cursor:'pointer'}}>
              <div className='thumbInner'>
              <div className={(props.face.isOnline ? 'onlineShow' : 'onlineHide')}>ONLINE</div>
              <div className={(props.face.hotDealPercent === 0 ? 'hotDealHide' : 'hotDealShow')}>{props.face.hotDealPercent}% OFF</div>
                <img onError={(e) => handleImageError(e)} src={`${currentThumbnailUrl}`}  width={props.imgWidth} height={props.imgHeight} alt={`Click to visit camgirl ${props.face.name}`} title={`Click to visit camgirl ${props.face.name}`} />
              </div>     
            </div>
            <div>              
              <span>
                <img src={`${siteICO}`} alt={`${props.face.site}`} title={`${props.face.site}`}  width={16} height={16}/>
                &nbsp;&nbsp;<span onClick={() => openInNewTab(currentPersonUrl)} style={{cursor:'pointer'}} title={`Click to visit camgirl ${props.face.name}`} data-toggle="tooltip">{props.face.name}</span>&nbsp;
                </span>
            </div>  
    </div>
  </div>
  );
}
export default TagModelComponent;